<script>
    export let roper;
    export let profile_img;

    let rank = 0;
    let today = 0;
    let total = 0;
    
    let average = 0;

    if (roper == "Roper 001") {
        rank = 2;
        total = 8975;
        today = 1000;
        average = total/4;
    } else if (roper == "Roper 002") {
        rank = 1;
        total = 12500;
        average = total/4;
    } else if (roper == "Roper 003") {
        rank = 3;
        total = 0;
        average = 0;
    }
</script>
<div id="container">
    <img id="pic" src="{profile_img}" />
    <h2>{roper}</h2>
    <h1 id="rank">
        #{rank}
    </h1>
    <div id="numbers">
        <div id="today">
            {today}
            <div>Today</div>
        </div>
        <div id="total">
            {total}
            <div>Total</div>
        </div>
        <div id="average">
            {average}
            <div>Average</div>
        </div>
    </div>
</div>

<style>
    h1,h2 {
        text-align: center;
    }
    #numbers {
        display: flex;
    }
    #numbers > div {
        margin: 7px;
        text-align: center;
    }
    #container {
        width: 300px;
        margin: 10px;
        position: relative;

        border: 1px solid #ffffff22;
        background-color: #282c34;
        background: linear-gradient(0deg, rgba(40,44,52,1) 0%, rgba(17,0,32,.5) 100%);
        box-shadow: 0 7px 20px 5px #00000088;
        border-radius: .7rem;
        backdrop-filter: blur(2px);
        -webkit-backdrop-filter: blur(7px);
        overflow: hidden;
        transition: .5s all;

        padding: 1rem;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: center;

        color: white;
    }
    #container:hover {
        border: 1px solid #ffffff44;
        box-shadow: 0 7px 50px 10px #000000aa;
        transform: scale(1.015);
        filter: brightness(1.3);
        cursor: pointer;
        }
    #container ::before {
  position: fixed;
  content: "";
  box-shadow: 0 0 100px 40px #ffffff08;
  top: -10%;
  left: -100%;
  transform: rotate(-45deg);
  height: 60rem;
  transition: 0.7s all;
}
#container:hover ::before {
  filter: brightness(0.5);
  top: -100%;
  left: 200%;
}
    #pic {
        max-width:150px;
        height: 150px;
        border-radius: 50%;
        border: 1px solid #ffffff22;
        box-shadow: 0 7px 20px 5px #00000088;
    }
</style>